import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import Tooltip from "../../common/ToolTip/ToolTip";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import styles from "./IconButton.module.css";
import AmpInlineLoadingSpinner from "../../common/AmpInlineLoadingSpinner/AmpInlineLoadingSpinner";

interface IconButtonProps {
    onClick?: React.MouseEventHandler<SVGSVGElement>;
    hasTooltip: boolean;
    tooltipDirection?: "left" | "right";
    tooltipContent?: string;
    icon: IconDefinition;
    usePending?: boolean 

}

export default function IconButton(props: IconButtonProps) {

    const onClick = (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
        e.stopPropagation();
        if(props.onClick) {
            props.onClick(e);
        }
        if(props.usePending){
            setPending(true);
        }
    }

    const [pending, setPending] = useState(false);

    const iconButton = !pending ? <FontAwesomeIcon className={props.onClick && styles.IconButton} icon={props.icon} size="lg" onClick={onClick} /> : <AmpInlineLoadingSpinner />
    const tooltipCorrect = props.hasTooltip && props.tooltipContent && props.tooltipDirection
    return (<>
        {tooltipCorrect && <Tooltip content={props.tooltipContent as string} direction={props.tooltipDirection as string} alignment={"left-text"}>
            {iconButton}
        </Tooltip>}
        {!tooltipCorrect && <>{iconButton}</>}
    </>)
}